import {
  AlertOutlined,
  PhoneOutlined,
  RiseOutlined,
  StarOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { SBIcon } from '@supplement-bacon/react-toolkit/components'
import { Card, Form, Space, Typography } from 'antd'
import { Audience as AudienceModel } from '../../../../models/Audience'
import Audience from '../../../audience/Audience'

const { Title, Text } = Typography

type Props = {
  audience: AudienceModel
  viewOnly?: boolean
  showOnlySubscribedCount?: boolean
}

export const AudienceCard = ({
  audience,
  viewOnly,
  showOnlySubscribedCount = false,
}: Props) => {
  const form = Form.useFormInstance()
  const audienceWatch = Form.useWatch('audience', form)

  const handleAudienceSelect = (audienceId: number) => {
    form.setFieldsValue({ audience: audienceId })
  }

  const icons = {
    UserOutlined: <UserOutlined />,
    AlertOutlined: <AlertOutlined />,
    StarOutlined: <StarOutlined />,
    RiseOutlined: <RiseOutlined />,
    TeamOutlined: <TeamOutlined />,
    PhoneOutlined: <PhoneOutlined />,
  }

  const setAudience = (audienceId: number) => {
    form.setFieldValue('audience', audienceId)
    handleAudienceSelect(audienceId)
  }

  return (
    <Card
      key={audience.id}
      onClick={() => !viewOnly && setAudience(audience.id)}
      style={{
        borderColor: audienceWatch === audience.id ? '#8e978a' : undefined,
        borderWidth: audienceWatch === audience.id ? 2 : 1,
        opacity: viewOnly && audienceWatch !== audience.id ? 0.4 : 1,
        cursor: viewOnly ? undefined : 'pointer',
      }}
    >
      <Space orientation="horizontal" className="w-full space-between">
        <Space size={20}>
          {audience.icon && (
            <Text style={{ fontSize: 20 }}>
              {icons[audience.icon as keyof typeof icons] ?? (
                <SBIcon name={audience.icon} />
              )}
            </Text>
          )}
          <Space orientation="vertical" size={0}>
            <Title level={5} className="m-0">
              {audience.title}
            </Title>
            <Text>{audience.description}</Text>
          </Space>
        </Space>
        <Audience.UsersCount
          audienceId={audience.id}
          showOnlySubscribedCount={showOnlySubscribedCount}
        />
      </Space>
    </Card>
  )
}
